import { useState, type ImgHTMLAttributes, type ReactNode } from 'react';
import { documentUrl } from '../api/client.ts';

/** A document thumbnail that falls back quietly if the file isn't an image or can't load. */
export function Thumb({ documentId, fallback = null, ...img }: { documentId: string; fallback?: ReactNode } & ImgHTMLAttributes<HTMLImageElement>) {
  const [failed, setFailed] = useState(false);
  if (failed) return <>{fallback}</>;
  return <img src={documentUrl(documentId)} loading="lazy" onError={() => setFailed(true)} {...img} />;
}
